import { FC, PropsWithChildren } from 'react';

import { IonButtons } from '@ionic/react';

import styles from './HeaderActions.module.scss';

type HeaderActionsProps = PropsWithChildren<{}>;

export const HeaderActions: FC<HeaderActionsProps> = ({ children }) => {
  return (
    <IonButtons slot="end" className={styles.root}>
      {children}
    </IonButtons>
  );
};
